import { Card, styled } from '@mui/material';

const SummaryCard = styled(Card)(({ theme, cardtype }) => ({
  height: '100%',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
  borderLeft: cardtype === 'income' 
    ? `4px solid ${theme.palette.success.main}` 
    : cardtype === 'expense' 
      ? `4px solid ${theme.palette.error.main}` 
      : cardtype === 'positive'
        ? `4px solid ${theme.palette.success.main}`
        : cardtype === 'negative'
          ? `4px solid ${theme.palette.error.main}`
          : `4px solid ${theme.palette.primary.main}`,
}));

export default SummaryCard; 